import { lazyWithPreload } from '@/shared/utils/lazyWithPreload';

/**
 * A supplier's own pages -- the wizard (Add, Edit, Duplicate) and View -- lazy, and preloadable (2026-10-28).
 *
 * The route table draws these, and the Supplier list preloads them while it is open, so View, Edit and Duplicate open
 * without the route's full-page spinner. Only dynamic imports here: the list importing this module pulls in no page.
 */
export const SupplierOnboardingFormPage = lazyWithPreload(() => import('./SupplierOnboardingFormPage'));
export const SupplierOnboardingViewPage = lazyWithPreload(() => import('./SupplierOnboardingViewPage'));

export function preloadSupplierRecordPages(): void {
  SupplierOnboardingFormPage.preload();
  SupplierOnboardingViewPage.preload();
}
